import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { ContentCarousel } from './components/ContentCarousel';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { ToolsSection } from './components/ToolsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1651357612587495';
type MetaPixel = {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-carbon text-mist selection:bg-gold/30 selection:text-white" data-id="element-0" data-mp="d3mkjc838xko">
      <main data-id="element-1" data-mp="86mcivrohkqx">
        <Hero data-id="element-2" data-mp="8648hcyry28g" />
        <TestimonialsStrip data-id="element-3" data-mp="83i3nl39q0tx" />
        <ContentCarousel data-id="element-4" data-mp="3gl4t5lvoq8m5" />
        <PainPoints data-id="element-5" data-mp="3gkl6xsz04y2b" />
        <SolutionReveal data-id="element-6" data-mp="3glwc9x83idvj" />
        <TomosSection data-id="element-7" data-mp="3gja2rs1n9oao" />
        <ToolsSection data-id="element-8" data-mp="3bmjsxmgfnoxp" />
        <BonusSection data-id="element-9" data-mp="3bn30qacdcwy0" />
        <PricingSection data-id="element-10" data-mp="3bnuwbl5yuuoa" />
        <ExtendedTestimonials data-id="element-11" data-mp="3bkgqu420a5cm" />
        <Guarantee data-id="element-12" data-mp="3qbppt3rst32f" />
        <FAQ data-id="element-13" data-mp="3qc950cq2ddcr" />
        <FinalCTA data-id="element-14" data-mp="3qcr0v88tdpk5" />
      </main>
      <Footer data-id="element-15" data-mp="3qd0tl3l8uatj" />
      <noscript data-id="element-16" data-mp="3lkr6rwffdqvh">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-17" data-mp="3lk7mi92ayqea" />
      </noscript>
      <PurchaseNotifications data-id="element-18" data-mp="2sv0qbgqbmcw7" />
    </div>;
}